export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de agroexportadoras"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "graph_link": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gráficos de ", _interpolate(_named("name"))])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of agro exporters"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "graph_link": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("name")), " graphs"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspections"])}
        }
      }
    }
  })
}